import { FieldValues } from "react-hook-form";
import { COMMON_CONSTANTS } from "src/constants/commonConstants";
import {
  AvailabilityRangeParams,
  AvailabilitySavePayload,
  HiringPreferencesApiPayload,
} from "src/models/availabilityPreferences.models";
import { EmailData } from "src/models/contact.models";
import { DeletePayloadProps } from "src/models/delete.account.models";
import { AccountEnableDisablePayload } from "src/models/enableDisableModal.model";
import commonUtils from "src/utils/common.utils";

import API_URL from "./apiConfig/api.config";
import handleResponse from "./apiConfig/api.response.service";
import apiCall from "./apiConfig/apiCall.config";

export async function editProfessionalEmail(uuid: string, payload: EmailData) {
  const url = commonUtils.getUrlReplace(
    API_URL.DENTAL_PROFESSIONAL.EDIT_EMAIL,
    COMMON_CONSTANTS.PROFESSIONAL_UUID,
    uuid
  );
  return await apiCall.patch(url, payload);
}

export async function enableOrDisableProfessionalAccount(
  professionalUuid: string,
  data: AccountEnableDisablePayload
) {
  const url = commonUtils.getUrlReplace(
    API_URL.PROFESSIONAL.ENABLE_DISABLE_ACCOUNT,
    COMMON_CONSTANTS.PROFESSIONAL_UUID,
    professionalUuid
  );

  return await apiCall.patch(url, data);
}

export async function deleteProfessionalAccount(
  professionalUuid: string,
  data: DeletePayloadProps
) {
  const url = commonUtils.getUrlReplace(
    API_URL.PROFESSIONAL.DELETE_ACCOUNT,
    COMMON_CONSTANTS.PROFESSIONAL_UUID,
    professionalUuid
  );

  return await apiCall.removeWithBody(url, data);
}
export const getProfessionalPreview = async (contractUuid: string) => {
  const url = API_URL.PROFESSIONAL.CONTRACT_PREVIEW.replace(
    COMMON_CONSTANTS.CONTRACT_UUID,
    contractUuid
  ).replace(/[{}]/g, "");
  const res = await apiCall.getBlobFile(url);
  return res;
};
export async function getProfessionalAccountActivity(professionalUuid: string) {
  const url = commonUtils.getUrlReplace(
    API_URL.PROFESSIONAL.GET_ACCOUNT_ACTIVITY_HISTORY,
    COMMON_CONSTANTS.PROFESSIONAL_UUID,
    professionalUuid
  );

  return await apiCall.get(url);
}

export const getJobHistoryProfessional = async (
  uuid: string,
  payload: { [key: string]: string | number | number[] } | undefined
) => {
  const url = API_URL.DENTAL_PROFESSIONAL.GET_JOB_HISTORY_PROFESSIONAL.replace(
    "professionalUuid",
    uuid
  ).replace(/[{}]/g, "");
  const res = await apiCall.get(url, payload);
  const responseData = await handleResponse(res);
  if (responseData.ok) {
    return responseData?.data;
  } else {
    return responseData;
  }
};

export async function verifyIdentification(uuid: string, payload: FieldValues) {
  const url = commonUtils.getUrlReplace(
    API_URL.DENTAL_PROFESSIONAL.VERIFY_IDENTIFICATION,
    COMMON_CONSTANTS.PROFESSIONAL_UUID,
    uuid
  );
  return await apiCall.patch(url, payload);
}

export async function getProfessionalAvailability(
  uuid: string,
  params: AvailabilityRangeParams
) {
  const url = commonUtils.getUrlReplace(
    API_URL.DENTAL_PROFESSIONAL.GET_AVAILABILITY,
    COMMON_CONSTANTS.UUID,
    uuid
  );
  return await apiCall.get(url, params);
}

export async function saveProfessionalAvailability(
  uuid: string,
  payload: AvailabilitySavePayload
) {
  const url = commonUtils.getUrlReplace(
    API_URL.DENTAL_PROFESSIONAL.SAVE_AVAILABILITY,
    COMMON_CONSTANTS.UUID,
    uuid
  );
  return await apiCall.patch(url, payload);
}

export async function getProfessionalHiringPreferences(uuid: string) {
  const url = commonUtils.getUrlReplace(
    API_URL.DENTAL_PROFESSIONAL.GET_HIRING_PREFERENCES,
    COMMON_CONSTANTS.UUID,
    uuid
  );
  return await apiCall.get(url);
}

export async function saveProfessionalHiringPreferences(
  uuid: string,
  payload: HiringPreferencesApiPayload
) {
  const url = commonUtils.getUrlReplace(
    API_URL.DENTAL_PROFESSIONAL.SAVE_HIRING_PREFERENCES,
    COMMON_CONSTANTS.UUID,
    uuid
  );
  return await apiCall.patch(url, payload);
}
